<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Cek Gadai</h5>
            </template>
			<div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="6">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal">
                            <div class="d-flex align-items-center search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterFromDate" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="input.filterToDate" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterJenisPinjaman" label="Jenis Pinjaman">
                            <b-form-select v-model="input.filterJenisPinjaman" id="filterJenisPinjaman" name="status" :options="jenisPinjamanOpt" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Jenis Pinjaman</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                type="search"
                                id="filterNoFaktur"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group class="form-inline filter-form-date filter-harga" label-for="filterFromPinjaman" label="Pinjaman">
                            <div class="d-flex align-items-center search-input-wrapper">
                                <b-input-group prepend="Rp">
                                    <b-form-input
                                        v-model="input.filterFromPinjaman" name="filterFromPinjaman"
                                        id="filterFromPinjaman"
                                    ></b-form-input>
                                </b-input-group>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-input-group prepend="Rp">
                                    <b-form-input 
                                        v-model="input.filterToPinjaman" name="filterToPinjaman"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </b-form-group>
						<b-form-group class="form-inline" label-for="showAllData" label="Tampilkan">
                            <b-form-select v-model="input.showAllData" id="showAllData" name="showAllData" :options="showOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Tampilkan</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <div label="Filter Cabang">
                            <multiselect
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih filter cabang --"
                            />
                        </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterSortPinjaman" label="Sorting Pinjaman">
                            <b-form-select v-model="input.filterSortPinjaman" id="filterSortPinjaman" name="filterSortPinjaman" :options="sortingOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Sorting Pinjaman</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
					<b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
			</div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataCekGadai" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data gadai untuk dicek.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <div>{{ row.item.noFaktur }}</div>
                    <div class="smallText text-muted">{{ row.item.cabang.name }}</div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div>
                        <p class="mb-0">{{row.item.jenisBarang.name}}</p>
                        <p class="mb-0 smallText text-muted">
                            {{row.item.merkBarang.name}} - {{row.item.tipeBarang.name}}
                        </p>
                        <p class="mb-0 smallText">
                            AM: <span v-if="row.item.kcs != null">{{row.item.kcs.status}}</span><span v-else>-</span>, 
                            KC: <span v-if="row.item.kc != null">{{row.item.kc.status}}</span><span v-else>-</span>, 
                            KU: <span v-if="row.item.ku != null">{{row.item.ku.status}}</span><span v-else>-</span>, 
                            PUSAT: <span v-if="row.item.pusat != null">{{row.item.pusat.status}}</span><span v-else>-</span> 
                        </p>
                    </div>
                </template>
                <template v-slot:cell(pinjamanPokok)="row">
                    <div>
                        <p class="mb-0">Rp. {{$helper.addThousandSeparator(row.item.pinjamanPokok)}}</p>
                        <div class="mb-0 smallText text-muted no-wrap">
                            Maks. Rp. {{$helper.addThousandSeparator(row.item.pinjamanMaksimal)}}
                        </div>
                    </div>
                </template>
                <template v-slot:cell(tanggal)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggal)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggal)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PENDING'">PENDING</b-badge>
                    <b-badge variant="primary" v-else-if="row.item.status == 'DALAM PENGECEKAN'">DALAM PENGECEKAN</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'YAKIN BENAR'">YAKIN BENAR</b-badge>
                    <b-badge variant="dark" v-else-if="row.item.status == 'PEMANTAUAN'">PEMANTAUAN</b-badge>
                    <b-badge variant="danger" v-else>YAKIN SALAH</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="cekGadaiDetailBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Pengecekan belum dilakukan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DALAM PENGECEKAN</h6>
                <p class="smallText mb-0">User sudah melihat data gadai dan sedang melakukan pengecekan lebih lanjut.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">YAKIN BENAR</h6>
                <p class="smallText mb-0">User menyatakan bahwa barang yang digadaikan adalah asli dan sesuai dengan data gadai.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">YAKIN SALAH</h6>
                <p class="smallText mb-0">User menyatakan bahwa barang yang digadaikan adalah salah / fraud.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">PEMANTAUAN</h6>
                <p class="smallText mb-0">Menandakan bahwa entri ini tidak membutuhkan approval / tindak lanjut.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'cek-gadai',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
				show: 10,
				showAllData: false,
                filterFromDate: null,
                filterToDate: null,
                filterFromPinjaman: null,
                filterToPinjaman: null,
                filterNoFaktur: null,
                filterCabang: null,
                filterStatus: null,
                filterSortPinjaman: 0,
                filterJenisPinjaman: 0,
                sortBy: null,
                sortDesc: null
			},
			sortingOption:[
                { id: 0, name: 'Tanpa Sortir' },
                { id: 1, name: 'Pinjaman Terbesar ke Terkecil' },
                { id: 2, name: 'Pinjaman Terkecil ke Terbesar' },
			],
			showOption:[
                { id: false, name: 'Semua' },
                { id: true, name: 'Yang belum diperiksa' },
			],
            fields: [
                { key: "noFaktur", label: "No. Faktur & Cabang" },
                { key: "barang", label: "Barang" },
                { key: "pinjamanPokok", label: "Pinjaman Pokok" },
                { key: "tanggal", label: "Tanggal" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [ 
                { id: 0, name: 'Pending' },
                { id: 1, name: 'Dalam Pengecekan' },
                { id: 2, name: 'Yakin Benar' },
                { id: 3, name: 'Yakin Salah' },
                { id: 9, name: 'Pemantauan' },
            ],
            jenisPinjamanOpt: [ 
                { id: 0, name: 'Semua' },
                { id: 1, name: 'Elektronik' },
                { id: 2, name: 'Kendaraan' },
                { id: 3, name: 'Emas' }
            ],
            cabangOption: [],
            dataCekGadai: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
	}, 
	watch:{
        "input.filterFromPinjaman": function(newValue) {
            if(newValue == null) { return }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.filterFromPinjaman = result);
        },
        "input.filterToPinjaman": function(newValue) {
            if(newValue == null) { return }
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.filterToPinjaman = result);
        },
    },
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

			let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getCekGadai= this.$axios.get("gadai-notifikasi/check/"+this.query).then(response => {
                this.dataCekGadai = response.data.data
                this.updateTotalItem(response.data.total)
        
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getCekGadai, getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getCekGadai(){
            this.toggleBusy()
            this.dataCekGadai = []

			const nominalMinPinjaman = this.$helper.removeThousandSeparator(this.input.filterFromPinjaman);
            const nominalMaxPinjaman = this.$helper.removeThousandSeparator(this.input.filterToPinjaman);

			if (this.input.showAllData == true) this.query = this.query + "&filterIncomplete=" + this.input.showAllData
            
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterJenisPinjaman)) this.query = this.query + "&filterJenisPinjaman=" + this.input.filterJenisPinjaman
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromPinjaman)) this.query = this.query + "&filterPinjamanMin=" + nominalMinPinjaman
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToPinjaman)) this.query = this.query + "&filterPinjamanMax=" + nominalMaxPinjaman
            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
			if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
			
			// sortByPinjamanAsc
            if(this.input.filterSortPinjaman == 1){
                this.query = this.query + "&sortByPinjamanAsc=false"
            }else if(this.input.filterSortPinjaman == 2){
                this.query = this.query + "&sortByPinjamanAsc=true"
			}
			
            this.$axios.get("gadai-notifikasi/check/"+this.query).then(response => {
                this.dataCekGadai = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
            
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getCekGadai()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getCekGadai()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
			this.input.showAllData = false
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterFromPinjaman = null
            this.input.filterToPinjaman = null
            this.input.filterNoFaktur = null
            this.input.filterCabang = null
            this.input.filterStatus = null
            this.input.filterJenisPinjaman = 0
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getCekGadai()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            // if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
            //     this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            // }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
            //     this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            // }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
            //     this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            // }else if(this.$helper.isNotNullAndNotEmpty(this.input.filterToPinjaman) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromPinjaman)){
            //     this.$helper.toastErr(this, "Mohon isi pinjaman dengan lengkap!")
            // }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToPinjaman) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromPinjaman)){
            //     this.$helper.toastErr(this, "Mohon isi pinjaman dengan lengkap!")
            // }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToPinjaman) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromPinjaman)) && (nominalMinPinjaman > nominalMaxPinjaman)){
            //     this.$helper.toastErr(this, "Range pinjaman tidak sesuai!")
            // }else{
            //     this.getCekGadai()
            // }

            this.getCekGadai()

        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        }

    },

    created(){
        this.init()
    }
}
</script>
